<template>
    <main-page v-show="!loading">
        <b-row class="p-3 mt-lg-5">
            <b-col class="m-auto" cols="12" md="6">
                <div class="shadow-lg bg-white" style="border-radius: 30px">
                    <div class="header">
                        <h4 class="title" v-tr>Change your password|Modifier votre mot de passe</h4>
                    </div>
                    <div class="reset-password">
                        <b-form-group>
                            <label v-tr>New password|Nouveau mot de passe</label>
                            <b-form-input :state="passwordValid" v-model="password" type="password" aria-describedby="password" maxlength="250"></b-form-input>
                            <b-form-invalid-feedback id="password" v-tr>Your password must have at least 8 characters, a number and an uppercase letter|Votre mot de passe doit avoir au moins 8 caractères, un chiffre et une lettre majuscule.</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group>
                            <label v-tr>Confirmation|Confirmation du mot de passe</label>
                            <b-form-input :state="confirmationValid" v-model="confirmation" type="password" aria-describedby="confirmation" maxlength="250"></b-form-input>
                            <b-form-invalid-feedback v-if="password" id="confirmation" v-tr>Oops, passwords don't match|Oups, les mots de passe sont différents</b-form-invalid-feedback>
                        </b-form-group>

                        <div class="text-right">
                            <b-btn @click="resetPassword" variant="primary" class="mt-2" :disabled="!formValid" v-tr>Reset|Valider</b-btn>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </main-page>
</template>

<script>
    import Network from "../../vue-components/helpers/Network";
    import Validation from "../../vue-components/helpers/Validation";

    export default {
        name: `recovery`,
        data() {
            return {
                loading: false,
                password: ``,
                confirmation: ``
            }
        },
        activated() {
            this.password = ``;
            this.confirmation = ``;
        },
        computed: {
            passwordValid() {
                return Validation.testPassword(this.password);
            },
            confirmationValid() {
                return this.passwordValid && this.password === this.confirmation;
            },
            formValid() {
                return this.passwordValid && this.confirmationValid;
            }
        },
        methods: {
            resetPassword() {
                if (this.password !== this.confirmation)
                    return;

                Network.post(`/wifi/client/user/reset-password`, {
                    guid: this.$route.params.guid,
                    password: this.password
                })
                    .then(() => {
                        this.$swal({
                            icon: `success`,
                            title: this.tr([`Success`, `Réinitialisé`]),
                            text: this.tr([`You password has been reset`, `Votre mot de passe a été modifié`])
                        }).then(() => {
                            this.$router.push(`/login`);
                        });
                    })
                    .catch(res => {
                        this.$swal({
                            icon: `error`,
                            title: this.tr([`No account found`, `Aucun compte associé`]),
                            text: this.tr([`This recovery link is not valid anymore`, `Ce lien de récupération de mot de passe n'est plus valide`])
                        });
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/style/welcome-page.scss";

    .reset-password {
        padding: 1.5rem 2rem;
    }

    .header {
        padding-top: 1rem;
        padding-bottom: 1rem;
        background-color: #57bfb2;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;

        .title {
            color: white;
            text-align: center;
            letter-spacing: 1px;
            font-size: 14pt !important;
            margin-bottom: 0;
        }
    }
</style>
